import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AppFooter = () => {
    const { t } = useTranslation();

    return (
        <footer className="border-t border-slate-200 bg-white py-4">
            <div className="mx-auto w-full max-w-6xl px-6 text-center text-xs text-slate-500">
                <div className="flex flex-wrap items-center justify-center gap-2 text-primary">
                    <Link to="/terms-conditions" className="hover:underline underline-offset-4">{t("COMMON_TERMS_AND_CONDITIONS")}</Link>
                    <span className="text-slate-300">|</span>
                    <Link to="/privacy-policy" className="hover:underline underline-offset-4">{t("COMMON_PRIVACY_POLICY")}</Link>
                </div>
                <p className="mt-1.5">{t("APP_FOOTER_COPYRIGHT")}</p>
            </div>
        </footer>
    );
};

export default AppFooter;
